<template>
  <ContentWrapper>
    <div class="content-heading">
      <div>전체 회원 조회</div>
      <!-- Breadcrumb right aligned-->
      <ol class="breadcrumb ml-auto">
        <li class="breadcrumb-item">
          <a href="#">Home</a>
        </li>
        <li class="breadcrumb-item">
          회원관리
        </li>
        <li class="breadcrumb-item active">
          <a href="/mem/memberList">전체 회원조회</a>
        </li>
      </ol>
    </div>
    <div class="card card-default" v-show="data.params.mode=='list'">
      <div class="card-body">
        <div class="form-row align-items-center">
          <!-- 기간검색 -->
          <SchDateRange label="가입일" :data="data" @search="search" @reset="reset" />
          <!-- 분류 -->
          <div class="form-group no-margin row" style="width:100%">
            <div class="col-auto">
              <label class="col-form-label">회원유형</label>
            </div>
            <div class="col-auto">
                <b-form-select :options="userTypeOption.array" v-model="data.params.typeCd" @change="search(1);" class="custom-select custom-select-sm"></b-form-select>
            </div>
            <div class="col-auto">
              <label class="col-form-label">교사인증유형</label>
            </div>
            <div class="col-auto">
                <b-form-select :options="certTypeCdOption" v-model="data.params.certTypeCd" @change="search(1);" class="custom-select custom-select-sm"></b-form-select>
            </div>
            <div class="col-auto">
              <label class="col-form-label">학교급</label>
            </div>
            <div class="col-auto">
                <b-form-select :options="schoolGrdCdOption" v-model="data.params.schlGrdCd" @change="schoolLevelChanged();" class="custom-select custom-select-sm"></b-form-select>
            </div>
            <div class="col-auto">
              <label class="col-form-label">과목</label>
            </div>
            <div class="col-auto">
                <b-form-select :options="subjectCdOption.values" v-model="data.params.subjectCd" @change="search(1);" class="custom-select custom-select-sm"></b-form-select>
            </div>
          </div>
          <div class="form-group no-margin row" style="width:100%">
            <div class="col-auto">
              <label class="col-form-label">이메일 동의</label>
            </div>
            <div class="col-auto">
                <b-form-select :options="YnOption" v-model="data.params.emailYn" @change="search(1);" class="custom-select custom-select-sm"></b-form-select>
            </div>
            <div class="col-auto">
              <label class="col-form-label">SMS 동의</label>
            </div>
            <div class="col-auto">
                <b-form-select :options="YnOption" v-model="data.params.smsYn" @change="search(1);" class="custom-select custom-select-sm"></b-form-select>
            </div>
          </div>
          <!-- 항목 검색 -->
          <sch-text label="검색어" :data="data" @search="search" @reset="reset"/>
        </div>
      </div>
    </div>
    <!-- // 검색 -->


    <!-- 목록 -->
    <div v-show="data.params.mode=='list'" class="card card-default">
      <div class="card-header mt-2">
        <span class="text-bold h4">목록</span>
        <div class="card-tool float-right" >
        </div>
        <ShowCounter label="Show" class="ml-1" :data="data" @search="search" />
      </div>
      <div class="card-body">
        <table class="table table-striped table-bordered table-hover">
          <thead>
            <tr>
              <td style="text-align:center">No</td>
              <td style="text-align:center">회원유형</td>
              <td style="text-align:center" @click="localSort.sort('loginId')">ID<em class="fa-2s mr-2 fas fa-sort"></em></td>
              <td style="text-align:center" @click="localSort.sort('name')">이름<em class="fa-2s mr-2 fas fa-sort"></em></td>
              <td style="text-align:center" @click="localSort.sort('schlNm')">학교/학원명<em class="fa-2s mr-2 fas fa-sort"></em></td>
              <td style="text-align:center">수신동의 (SMS / E-mail)</td>
              <td style="text-align:center" @click="localSort.sort('regDt')">가입일(승인일)<em class="fa-2s mr-2 fas fa-sort"></em></td>
              <td style="text-align:center" @click="localSort.sort('lastLoginDt')">최근접속일<em class="fa-2s mr-2 fas fa-sort"></em></td>
            </tr>
          </thead>
          <tbody>
            <tr v-show="data.count==0" class="text-center"><td colspan="9">No matching records</td> </tr>
            <tr v-show="data.count!=0" v-for="(item, index) in data.list" :key="index"  > <!--  @click.prevent="goDetail(item.seq);" -->
              <td class="align-middle text-center" @click="goDetail(item.loginId,item.typeCd)">{{data.params.limit*(data.params.page-1) + index+1}}</td>
              <td class="align-middle text-center" @click="goDetail(item.loginId,item.typeCd)">
                {{userTypeOption.getUserTypeText(item.typeCd)}}
              </td>
              <td class="align-middle text-center" @click="goDetail(item.loginId,item.typeCd)">{{item.maskedLoginId}}</td>
              <td class="align-middle text-center" @click="goDetail(item.loginId,item.typeCd)">{{item.name}}</td>
              <td class="align-middle text-center" @click="goDetail(item.loginId,item.typeCd)">{{item.schlNm}}</td>
              <td class="align-middle text-center" @click="goDetail(item.loginId,item.typeCd)">
                  {{item.smsYn == 'Y' ? 'sms' : 'X' }} / {{item.emailYn == 'Y' ? 'e-mail' : 'X' }}
              </td>
              <td class="align-middle text-center" @click="goDetail(item.loginId,item.typeCd)">{{item.regDt != null ? item.regDt.substr(0,10) : ''}}</td>
              <td class="align-middle text-center" @click="goDetail(item.loginId,item.typeCd)">{{item.lastLoginDt != null ? item.lastLoginDt.substr(0,10) : ''}}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="card-footer">
        <div class="d-flex">
          <!--paging component-->
          <Pagenation :data="data" @next="dataAction.next(search)" @prev="dataAction.prev(search)" @first="dataAction.first(search)" @last="dataAction.last(search)" :key="data.params.page"/>
        </div>
      </div>
    </div>
    <!-- // 목록 -->

    <loading :active="modalLoading" :is-full-page="true"/>
  </ContentWrapper>
</template>
<script>
import Vue from 'vue';
import store from "@/store/index";
import { reactive, ref, computed, onMounted, onUnmounted ,onBeforeMount} from '@vue/composition-api'
import {dataObject,userTypeCd, ValueTexts, subjectCd1, subjectCd2, subjectCd3} from "@/utils/Constants";
import {getUserList} from "@/api/mem/MemberAPI";
import Pagenation from "@/components/Common/Pagenation";
import {TableActionClass} from "@/utils/TableActionClass";
import SchDateRange from "../../components/Common/SchDateRange";
import SchText from "../../components/Common/SchText";
import ShowCounter from "../../components/Common/ShowCounter";
import Keyword from "../../components/Common/Keyword";
import Datepicker from 'vuejs-datepicker';
import swal from 'sweetalert2'
import Axios from 'axios';
import moment from 'moment';

// 로딩처리
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

import draggable from 'vuedraggable'
// 목차/차시/파일
import vueMoment from 'vue-moment' 

Vue.use(vueMoment)

export default {
  components: {SchText, ShowCounter, Pagenation,  Loading, draggable, Keyword,SchDateRange, Datepicker},

  setup(props, {root}){
    const modalLoading = ref(false);

    const _dataObject = _.cloneDeep(dataObject);
    _dataObject.params.typeCd = '';
    _dataObject.params.certTypeCd = '';
    _dataObject.params.schlGrdCd = '';
    _dataObject.params.subjectCd = '';
    _dataObject.params.smsYn = '';
    _dataObject.params.emailYn = '';
    const data = reactive(_dataObject);
    data.schOptions = [
      {value:'name', text:'이름'},
      {value:'loginId', text:'ID'},
      {value:'schlNm', text:'학교명/학원명'},
      //{value:'phone', text:'전화번호'},
      //{value:'address', text:'주소'},
    ]

    // Select Options
    const userTypeOption = new ValueTexts(userTypeCd);

    const certTypeCdOption = ref([
      {value:'', text:'전체'},
      {value:'complete', text:'인증완료'},
      {value:'epki', text:'EPKI 인증'},
      {value:'file', text:'서류 인증'},
      {value:'wait', text:'서류 인증 대기'},
      {value:'none', text:'인증없음'}
    ]);

     //학교급, 학년 선언
    const schoolGrdCdOption = ref([
      {value:'',text:'전체'},
      {value:'301002',text:'초등'},
      {value:'301003',text:'중등'},
      {value:'301004',text:'고등'}
    ]);

    const subjectCdOption = reactive({
      values:[
        {value:'',text:'학교급을 선택해주세요.'},
      ]});

    const YnOption = ref([
      {value:'', text:'전체'},
      {value:'Y', text:'동의'},
      {value:'N', text:'미동의'},
    ]);

    const retVals = {
      userTypeOption,
      certTypeCdOption,
      schoolGrdCdOption,
      subjectCdOption,
      subjectCd1,
      subjectCd2,
      subjectCd3,
      YnOption,
      data,
      modalLoading,
      ...methods(),
      dataAction: new TableActionClass(data),
      localSort:root.$_localSort
    }

    onMounted(async () => {
      if (store.state.params.name == 'memberList') {
        retVals.data.params = store.state.params.data;
        store.commit('setParams', {name:'', data:undefined});
      }
      await retVals.search();
    })

    return retVals;
  },
}

function methods() {

  async function schoolLevelChanged() {
    const allSubject = {value:'', text:'전체'};

    switch(this.data.params.schlGrdCd){
      case '301002' : 
        this.subjectCdOption.values = [allSubject, ...subjectCd1];
        break;
      case '301003' : 
        this.subjectCdOption.values = [allSubject, ...subjectCd2];
        break;
      case '301004' : 
        this.subjectCdOption.values = [allSubject, ...subjectCd3];
        break;
      case '':
        this.subjectCdOption.values =[{value:'',text:'학교급을 선택해주세요.'}];
        break;
    }
    this.data.params.subjectCd = '';
    this.search(1);
  }

  // 목록
  async function search(page) {
    if (!isNaN(page)) {
      this.data.params.page = page;
    }
    let result = await getUserList(this.data.params);
    this.data.list = result.data;
    this.data.count = result.count;
    this.localSort.set(this.data.list);
  }

  // 상세
  async function goDetail(loginId, typeCd){
    this.$store.commit('setParams', {name:'memberList', data:this.data.params});
    this.$router.push({name:'memberDetail', params:{loginId:loginId, typeCd:typeCd}});
  }

  // 초기화
  async function reset(){
    this.data.params.mode="list";
  }

  return {
    schoolLevelChanged,
    search,
    goDetail,
    reset,
  }
}

</script>
